import { render, staticRenderFns } from "./dropdownMenu.vue?vue&type=template&id=c5746572&scoped=true&"
import script from "./dropdownMenu.vue?vue&type=script&lang=js&"
export * from "./dropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./dropdownMenu.vue?vue&type=style&index=0&id=c5746572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5746572",
  null
  
)

export default component.exports